import { AccountPermission } from 'modules/permissions/constants';
import { Placeholder } from 'modules/common/components/Placeholder';
import { UpgradePlanDialog } from 'modules/common/components/UpgradePlanDialog';
import { useCheckAccountPermission } from 'modules/account/hooks/useCheckAccountPermission';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { PlanButton } from '../PlanButton';
import { paygPlanButtonTranslation } from './translation';
import { usePAYGPlanButton } from './hooks/usePYAGPlanButton';

export interface PAYGPlanButtonProps {
  className?: string;
  onClick?: () => void;
}

export const PAYGPlanButton = ({
  className,
  onClick: onClickExternal,
}: PAYGPlanButtonProps) => {
  const {
    closeUpgradePlanDialog,
    disabled,
    isLoggedIn,
    isUpgradePlanDialogOpened,
    onClick,
  } = usePAYGPlanButton({ onClickExternal });

  const hasBillingAccess = useCheckAccountPermission({
    permission: AccountPermission.Billing,
  });

  const { keys, t } = useTranslation(paygPlanButtonTranslation);

  return (
    <>
      <PlanButton
        className={className}
        disabled={disabled}
        onClick={onClick}
        variant="contained"
      >
        {t(keys.getStarted)}
      </PlanButton>
      <Placeholder
        hasPlaceholder={!isLoggedIn || !hasBillingAccess}
        placeholder={null}
      >
        <UpgradePlanDialog
          onClose={closeUpgradePlanDialog}
          open={isUpgradePlanDialogOpened}
        />
      </Placeholder>
    </>
  );
};
